import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Grid, Typography, Button } from "@mui/material";
import { APP_ROUTES, MAIN_ROUTES } from "../../../../_config/routes";

import { findAllClientsNamesByCompanyEvent } from '../../../../_events/clients/find_clients.event';
import { message } from 'antd';
import InfoClientModal from "./table_client";

const GeneralClientInfoGroup = () => {
  const [clients, setClients] = useState(null);
  const [filteredClients, setFilteredClients] = useState(null);
  const [loading, setLoading] = useState(true);

  const findClientNames = () => {
    findAllClientsNamesByCompanyEvent()
      .then((data) => {
        setClients(data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        message.err(err);
      });
  };

  const filterClients = (filterValue) => {
    const filter = clients
      ? clients.filter((client) =>
          client.name.toLowerCase().includes(filterValue.toLowerCase())
        )
      : [];

    setFilteredClients(filter);
  }

  useEffect(() => {
    findClientNames();
  }, []);  

  const inputStyle = {
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    marginRight: "10px",
    fontSize: "14px",
    width: "200px",
    outline: "none", 
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12}>
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <Typography variant="h6" component="h6">
            Listado de Clientes
          </Typography>
          {/*}
          <Link to={`${MAIN_ROUTES.app_modules}${APP_ROUTES.orders_history_group_date}`}>
            <Button style={{ marginLeft: '15px' }} variant="contained" size="small">Agrupación fecha</Button>
          </Link>
          */}
        </div>
        <hr />
        {loading ? 'Cargando...' : (
          <div>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "12px", flexDirection: "row-reverse" }}>
              <input
                type="text"
                placeholder="Buscar cliente"
                style={inputStyle}
                onChange={(e) => filterClients(e.target.value)}
              />
              <p style={{ marginRight: "10px" }}>Nombre de cliente:</p>
            </div>

            {/** Este modal maneja la informacion de la lista de nombres del cliente */}
            <InfoClientModal
              clients={!filteredClients ? clients : filteredClients}
            />
          </div>
        )}
      </Grid>
    </Grid>
  );
}

export default GeneralClientInfoGroup;
